import { generateEntityCrudActionTypes } from 'syft-acp-util/store/action-types'

const commissionsSales = generateEntityCrudActionTypes('commissionsSales')

export default { ...commissionsSales }
